import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

type AuthLegalNoticeProps = {
  className?: string;
};

export function AuthLegalNotice({ className }: AuthLegalNoticeProps) {
  return (
    <p className={cn("text-xs text-muted-foreground text-center leading-relaxed", className)}>
      By continuing you agree to our{" "}
      <Link
        to="/terms"
        className="underline underline-offset-2 hover:text-foreground transition-colors"
      >
        Terms
      </Link>{" "}
      &amp;{" "}
      <Link
        to="/privacy"
        className="underline underline-offset-2 hover:text-foreground transition-colors"
      >
        Privacy Policy
      </Link>
      .
    </p>
  );
}
